export default __webpack_public_path__ + "static/media/angpao.6a28aaae.webp";